import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header";
const route = all_routes;
const Notifications = () => {
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">Settings</h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}

              <div className="row">
                <div className="col-xl-3 col-lg-12 theiaStickySidebar">
                  {/* Settings Sidebar */}
                  <div className="card">
                    <div className="card-body">
                      <div className="settings-sidebar">
                        <h4 className="fw-semibold mb-3">General Settings</h4>

                        <div className="box box-default">
                          <div className="box box-default">
                            <div
                              className="box-header"
                              style={{
                                borderBottom: "0px",
                                marginBottom: "5px",
                              }}
                            >
                              <h5 className="box-title">
                                System Email Setting
                              </h5>
                            </div>

                            <div className="box-body">
                              <dl className="dl-horizontal">
                                <dt>Type</dt>
                                <dd>system</dd>
                                <dt>Driver Name</dt>
                                <dd>smtp</dd>
                                <dt>Host Name</dt>
                                <dd>smtp.sendgrid.net</dd>
                                <dt>Username</dt>
                                <dd>apikey</dd>
                                <dt>Sender Email</dt>
                                <dd>noreply@prosperumfunds.com</dd>
                                <dt>Sender Name</dt>
                                <dd>prosperfunds</dd>
                                <dt>Update </dt>
                                <dd>
                                  <a
                                    href="/smtp/20"
                                    style={{ color: " #00a7d0" }}
                                  >
                                    {" "}
                                    System Email Setting
                                  </a>
                                </dd>
                              </dl>
                            </div>
                          </div>

                          <div
                            className="box-header"
                            style={{ borderBottom: "0px",marginBottom:'5px' }}
                          >
                            <h5 className="box-title">Demo Logo</h5>
                          </div>

                          <div className="box-body">
                            <div className="container_css">
                              <img
                                src="https://portal.voiptella.com/logo/client_3.png"
                                alt="Avatar"
                                className="profile-user-img img-responsive image"
                                style={{ border: "none",marginBottom:'5px' }}
                              />

                              <div className="overlay">
                                <form
                                  id="form"
                                  action="https://portal.voiptella.com/logo-upload"
                                  method="POST"
                                >
                                  <input
                                    type="hidden"
                                    name="_token"
                                    value="y5rTqMfnEX29A4lMScBI2GYFJZsQ1VboARnumbMB"
                                  />{" "}
                                  <input
                                    type="hidden"
                                    id="old_logo"
                                    name="old_logo"
                                    value="client_3.png"
                                  />
                                  <input
                                    id="html_btn"
                                    name="image"
                                    type="file"
                                  />
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Settings Sidebar */}
                </div>
                <div className="col-xl-9 col-lg-12">
                  {/* Settings Info */}
                  <div className="card">
                    <div className="card-body">
                      <h4 className="fw-semibold mb-3">
                        Notification Settings
                      </h4>
                      <div className="settings-form">
                        {/* General Notifications */}
                        <div className="border-bottom mb-3 pb-3">
                          <h5 className="fw-semibold mb-1">
                            General Notifications
                          </h5>
                          <p>Select notifications</p>
                        </div>
                        <div className="border-bottom mb-3 pb-3">
                          <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-3">
                            <label
                              className="form-check-label text-gray-9 fw-medium"
                              htmlFor="notification1"
                            >
                              Mobile Push Notifications
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue=""
                              id="notification1"
                              defaultChecked
                            />
                          </div>
                          <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-3">
                            <label
                              className="form-check-label text-gray-9 fw-medium"
                              htmlFor="notification2"
                            >
                              Desktop Notifications
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue=""
                              id="notification2"
                              defaultChecked
                            />
                          </div>
                          <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-3">
                            <label
                              className="form-check-label text-gray-9 fw-medium"
                              htmlFor="notification3"
                            >
                              Email Notifications
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="notification3"
                              defaultChecked
                            />
                          </div>
                          <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-0">
                            <label
                              className="form-check-label text-gray-9 fw-medium"
                              htmlFor="notification4"
                            >
                              SMS Notifications
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="notification4"
                              defaultChecked
                            />
                          </div>
                        </div>
                        {/* /General Notifications */}
                        {/* Custom Notifications */}
                        <div className="border-bottom mb-3 pb-3">
                          <h5 className="fw-semibold mb-1">
                            Custom Notifications
                          </h5>
                          <p>
                            Select when you will be notified when the following
                            changes occur{" "}
                          </p>
                        </div>
                        <div className="table-responsive notificaion-table">
                          <table className="table table-borderless">
                            <thead>
                              <tr>
                                <th />
                                
                                <th>SMS</th>
                                <th>Email</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Notification for list uploaded/deleted</td>
                               
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Notification for extension create/delete</td>
                              
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Notification for campaign low leads</td>
                               
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Daily call report</td>
                              
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Notification for lead recycle</td>
                                
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>IP Whitelisting notification</td>
                               
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Fax Notification</td>
                              
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Callback Notification</td>
                               
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      defaultChecked
                                    />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* /Custom Notifications */}
                      </div>
                    </div>
                  </div>
                  {/* /Settings Info */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Delete Account */}
      <div
        className="modal custom-modal fade"
        id="delete_account"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon">
                  <i className="ti ti-trash-x" />
                </div>
                <h3>Delete Account</h3>
                <p className="del-info">Are you sure want to delete?</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to={route.security} className="btn btn-danger">
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Account */}
    </div>
  );
};

export default Notifications;
